import { useContext } from 'react'
import { buildVectorTileLayerDefaultOptions } from '../utils'
import { VectorGrid } from './VectorGrid'
import LayersContext from '../../../contexts/Layers'
import { TaxonomicPlotPopup } from '../Popups/TaxonomicPlotPopup'
import { useLayerPopupHandler } from '../hooks'
import { api } from '../../../config'

const layerName = 'taxonomicPlots'
const layerSource = 'stand_grid'
const vectorGridProps = {
  options: {
    zIndex: 4,
    vectorTileLayerStyles: {
      [layerSource]: {
        ...Object.values(
          buildVectorTileLayerDefaultOptions(layerName, layerSource).vectorTileLayerStyles
        )[0],
        fillOpacity: 0,
      },
    },
  },
  url: `${api.host}/vector_tiles/${layerSource}/{z}/{x}/{y}.pbf`,
  activeStyles: {
    fillOpacity: 0,
    weight: 4,
  },
}

export const TaxonomicPlotsLayer = () => {
  const { selected } = useContext(LayersContext)
  const active = selected.includes(layerName)

  const [popupProps, handleClick] = useLayerPopupHandler(active)

  return active ? (
    <>
      <VectorGrid {...vectorGridProps} onClick={handleClick} />
      {popupProps ? <TaxonomicPlotPopup {...popupProps} /> : null}
    </>
  ) : null
}
